import styled from "@xstyled/styled-components";

import { CandidateCardActions } from "../interfaces";

import { CandidateCardFragment } from "@hire/schema";
import { Button } from "@otta/design";
import { Experiment } from "@hire/constants/experiments";
import { useExperiment } from "@otta/experiments/client";

const Container = styled.div`
  display: flex;
  gap: sm;
`;

interface CandidateActionButtonsProps extends CandidateCardActions {
  candidate: CandidateCardFragment;
}

export function CandidateActionButtons({
  candidate,
  messageCandidate,
  removeCandidate,
  shortlistCandidate,
}: CandidateActionButtonsProps): React.ReactElement | null {
  const { variant } = useExperiment(Experiment.MessagingDisabled);
  const messagingDisabledEnabled = variant === "variant";

  return (
    <Container>
      {shortlistCandidate && (
        <Button
          level="secondary"
          onClick={e => {
            e.stopPropagation();
            shortlistCandidate(candidate.externalId);
          }}
        >
          Shortlist
        </Button>
      )}
      {removeCandidate && (
        <Button
          level="secondary"
          onClick={e => {
            e.stopPropagation();
            removeCandidate(candidate.externalId);
          }}
        >
          Remove
        </Button>
      )}
      {messageCandidate && !messagingDisabledEnabled && (
        <Button
          level="primary"
          onClick={e => {
            e.stopPropagation();
            messageCandidate(candidate.externalId);
          }}
        >
          Message
        </Button>
      )}
    </Container>
  );
}
